import { render, staticRenderFns } from "./invitePortalQuestionnaire.vue?vue&type=template&id=47b38b35&scoped=true"
import script from "./invitePortalQuestionnaire.vue?vue&type=script&lang=js"
export * from "./invitePortalQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b38b35",
  null
  
)

export default component.exports